module.exports = require('./helpers/bundle-url').getBundleURL('1l2aU') + "logo-dark.ba5147f0.svg";